module.exports = __webpack_public_path__ + "fonts/00f4610c11ae2aeb7db685df41262363.eot";